var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6692 4.73923L0.5 16.9083V20H3.59146L15.7598 7.83005L12.6692 4.73923Z",
    fill: "#DD1B78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8588 0.640084C19.4487 0.230234 18.8928 0 18.313 0C17.7333 0 17.1773 0.230234 16.7673 0.640084L13.8508 3.5609L16.9415 6.65172L19.8579 3.73507C20.0614 3.53203 20.2229 3.29085 20.333 3.02535C20.4432 2.75984 20.5 2.47521 20.5001 2.18775C20.5001 1.90029 20.4435 1.61563 20.3335 1.35006C20.2235 1.0845 20.0621 0.843236 19.8588 0.640084Z",
    fill: "#DD1B78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMobile);
export default __webpack_public_path__ + "static/media/editMobile.7707fd626ac996f19f367b9969517819.svg";
export { ForwardRef as ReactComponent };